import { render, staticRenderFns } from "./AllotStore.vue?vue&type=template&id=7b9affc8&scoped=true"
import script from "./AllotStore.vue?vue&type=script&lang=js"
export * from "./AllotStore.vue?vue&type=script&lang=js"
import style0 from "./AllotStore.vue?vue&type=style&index=0&id=7b9affc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9affc8",
  null
  
)

export default component.exports